import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../../configs/AppConfig";
import {AUTH_TIPE} from "../../constants/AuthConstant";

const  taliAsihService = {}

taliAsihService.data = function (token,data='') {
    return fetch({
        url: '/ref/tali_asih/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

taliAsihService.show = function (token,data='') {
    return fetch({
        url: '/ref/tali_asih/show',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

taliAsihService.data_import = function (token,data) {
    return fetch({
        url: '/ref/tali_asih/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

taliAsihService.empty_import = function (token,data) {
    return fetch({
        url: '/ref/tali_asih/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

taliAsihService.save_import = function (token,data) {
    return fetch({
        url: '/ref/tali_asih/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

export default taliAsihService;
